<template>
    <div class="index">
        <div class="top clearfix">
            <div class="logo left">
                <div class="logo-img  flex flex-align-center flex-pack-center">
                    <img src="./../../assets/logo1.png" height="40" width="121" alt="">
                </div>
            </div>
            <div class="topCenterBox position-center-middle">
                <div class="top_item left" v-for='(item,ind) in topBar' :class="{'top_item_active_class':item.isOpen}">
                    <div v-if="!item.son.length" @click="handle(item,ind)">
                       <router-link class="drop-down-item" :to="item.routeName" tag="p" :key="ind" active-class="top_item_active_class" v-text="item.name"></router-link>
                    </div>
                    <div v-else>
                        <p v-text="item.name"></p>
                        <div class="drop-down-box" @click="handle(item,ind)">
                            <router-link class="drop-down-item" :to="oitem.routeName" tag="div" :key="oind" v-for='(oitem,oind) in item.son' v-text="oitem.name" active-class="active_class"> 
                                
                            </router-link>
                        </div>
                    </div>

                </div>
            </div>
            <div class="user clearfix">
                <div class="left userLeft">
                    <p v-text="store.storeName"></p>
                    <p v-text="store.employeeName"></p>
                </div>
                <div class="left userIcon flex flex-align-center flex-pack-center">
                    <i class="iconfont icon-yonghu1"></i>
                </div>
                <div class="right useRight flex flex-align-center flex-pack-center" >
                    <i class="iconfont icon-xiala"></i>
                    <i class="iconfont icon-shangla"></i>
                </div>
                <div class="logoOutBox">
                    <p v-text="store.storeName"></p>
                    <div class="btn" @click="cutStore"><i class="iconfont icon-exchange2jiaohuan"></i>切换店铺</div>
                    <p>当前帐号</p>
                    <p v-text="store.employeeName"></p>
                    <div class="btn" @click="logout"><i class="iconfont icon-icon"></i>退出登录</div>
                </div>
            </div>
        </div>
        <router-view class="router-view-box" :storeId ="storeId" :store ="store"></router-view> 
    </div>
</template>
<script type="text/javascript">
export default{
    data(){
        return {
            topBar:[
                {
                    name:"首页",
                    son:[
                       
                    ],
                    isOpen:1,
                    routeName:`/Home`,
                    isActive:0, 
                },
                {
                    name:"仓库",
                    son:[
                        {name:'入库',routeName:`/Stock_Inner`},
                        {name:'出库',routeName:`/Stock_Outer`},
                        {name:'仓库盘点',routeName:`/Stock_Check`},
                        {name:'出入库记录',routeName:`/Stock_Record`}
                    ],
                    isOpen:false,
                    routeName:null
                },
                {
                    name:"吧台",
                    son:[
                        {name:'上架',routeName:`/Bar_Inner`},
                        {name:'下架',routeName:`/Bar_Outer`},
                        {name:'吧台盘点',routeName:`/Bar_Check`},
                        {name:'出入库记录',routeName:`/Bar_Record`}
                    ],
                    isOpen:false,
                    routeName:null
                }
            ],
            storeId:'',
            store:{}
        }
    },
    watch: {
        '$route':function (val) {
            this.initActiveClass();
        }
    },
    methods: {
        //切换top-item的下边框
        handle(item,ind){
            for(var i = 0,len = this.topBar.length; i < len;i++){  
               this.topBar[i].isOpen = false;
            }
            this.topBar[ind].isOpen = true;
        },
        initActiveClass(){
            let ind= 0;
            for(var i = 0,len = this.topBar.length; i < len;i++){
                this.topBar[i].isOpen = false;
                if(this.topBar[i].son.length) {
                    for(var j = 0,lens = this.topBar[i].son.length; j < lens;j++){
                           
                        if(this.topBar[i].son[j].routeName=='/'+this.$route.name){
                            ind = i;
                        };
                    }
                }else{
                    ind = i;
                }
            };
            this.topBar[ind].isOpen = true;
        },
        logout(){
            this.$http.post('/logout', {}).then((res)=>{
                localStorage.clear();
                sessionStorage.clear();
                this.$router.push('/login')
            }).catch((err)=>{

            })
        },
        cutStore(){
            if ( !JSON.parse(sessionStorage.getItem('allStore')) ) {
                this.$router.push('login');
                return;
            }else{
                if ( JSON.parse(sessionStorage.getItem('allStore')).length<=1 ) {
                    this.$message({
                        showClose: true,
                        message: '无更多店铺',
                        type: 'error'
                    })
                    return;
                }else{
                    this.$router.push('ChoiceStore');
                };
            }
        }
    },
    created: function () {
        if ( !JSON.parse(sessionStorage.getItem('store')) ) {
            this.$router.push('login');
            return;
        }
        this.store = JSON.parse(sessionStorage.getItem('store'));
        this.storeId = JSON.parse(sessionStorage.getItem('store')).storeId;
        this.initActiveClass();
    },
    mounted: function () {
    },
    beforeDestroy: function () {
        // sessionStorage.removeItem('store');
        // sessionStorage.removeItem('token');
    }
  }
</script>
<style lang="scss" scoped>
  @import "index";
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue